<admin-panel-empty *ngIf="spaces.length > 0; else noSelectedChannels">
  <admin-table-standard [items]="spaces">
    <ng-template #header>
      <th style="width: 10%">{{ 'pages.tables.spaces.code' | translate }}</th>
      <th style="width: 15%">{{ 'pages.tables.spaces.name' | translate }}</th>
      <th style="width: 45%">{{ 'pages.tables.spaces.description' | translate }}</th>
      <th style="width: 10%">{{ 'pages.tables.spaces.machine' | translate }}</th>
      <th style="width: 10%">{{ 'pages.tables.spaces.status' | translate }}</th>
      <th style="width: 10%">&nbsp;</th>
    </ng-template>
    <ng-template #first let-item>
      <td>{{item.code}}</td>
      <td>{{item.name}}</td>
      <td>{{item.description}}</td>
      <td [ngClass]="item.active ? 'text-success' : 'text-warning'">{{ item.active ? "on" : "off" }}</td>
      <td [ngClass]="item.enabled ? 'text-success' : 'text-warning'">{{ item.enabled ? "enabled" : "disabled" }}</td>
      <td class="justify-content-around text-end ps-0 pe-0 weight-label">
        <a role="button" (click)="manage(item)" class="text-decoration-none text-purple action-buttons">
          <i class="bi bi-pencil-square" style="padding-left: 10px; padding-right: 10px;"></i>Manage
        </a>
      </td>
    </ng-template>
  </admin-table-standard>
</admin-panel-empty>

<ng-template #noSelectedChannels>
  <h5 class="border-top border-1 pt-3">No tenants found.</h5>
</ng-template>
